import { useUnderMaintenanceStyles } from './SamparkLayout.styles';

export const UnderMaintenance = () => {
  const { classes } = useUnderMaintenanceStyles();
  return <div className={classes.underMaintenanceContainer}>Under Maintenance</div>;
};
